var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#search-sm_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3.2 8.3.064.005a.417.417 0 0 1 .325.262l.401 1.044c.073.189.087.215.1.234.018.025.04.047.065.065.019.013.045.027.234.1l1.044.401a.417.417 0 0 1 0 .779l-1.044.4c-.189.072-.215.086-.234.1a.28.28 0 0 0-.065.066c-.013.018-.027.045-.1.233l-.401 1.044a.417.417 0 0 1-.389.267l-.063-.005a.417.417 0 0 1-.326-.262l-.4-1.044a1.296 1.296 0 0 0-.1-.233.285.285 0 0 0-.067-.066c-.018-.014-.046-.028-.233-.1l-1.044-.4a.417.417 0 0 1 0-.779l1.044-.401c.188-.073.215-.087.233-.1a.283.283 0 0 0 .067-.065c.013-.019.027-.045.1-.234l.4-1.044.028-.058a.417.417 0 0 1 .361-.21ZM7.328.7A4.028 4.028 0 0 1 10.582 7.1l2.535 2.534a.625.625 0 0 1-.884.884L9.698 7.982A4.029 4.029 0 1 1 7.328.7Zm0 1.25a2.778 2.778 0 1 0 0 5.556 2.778 2.778 0 0 0 0-5.556Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "search-sm_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
SvgSearchSm.displayName = "SvgSearchSm";
export { SvgSearchSm as ReactComponent };
export default SvgSearchSm;